import { useState, useRef, useMemo, useEffect } from "react";
import { useTouchClick } from "shared/hooks/useTouchClick";
import categorySound from "resources/music/물방울.mp3";
import btnSound from "resources/music/button-pressed-38129.mp3";
import HorizontalBackButton from "../../process/Button/HorizontalBackButton";
import StretchableHorizontalSlider from "../../process/pagination/StretchableHorizontalSlider";
import SkeletonProductCard from "../../process/card/SkeletonProductCard";
import ProductCard3 from "./ProductCard3";
import SimplePagination from "../../process/pagination/SimplePagination";
import SoldOutProductCard from "../../process/card/SoldOutProductCard";

function DemoHorizontalProductListView({
    currentPage,
    setCurrentPage,
    filteredProducts,
    setViewData,
    onGoBackBtnClick,
    currentProductIndex,
    setCurrentProductIndex,
    isLoading
}) {
    const itemsPerPage = 10;
    const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);
    const audioRef = useRef();
    const audio1Ref = useRef();

    // pagingData 생성을 위한 useMemo
    const pagingData = useMemo(() => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;

        return {
            hasPrevious: startIndex > 0,
            hasNext: endIndex < filteredProducts.length
        };
    }, [currentPage, filteredProducts, itemsPerPage]);

    const getCurrentPageItems = () => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const currentItems = filteredProducts.slice(startIndex, startIndex + itemsPerPage);

        // 현재 페이지의 실제 아이템 수가 itemsPerPage보다 적으면 SkeletonProductCard 추가
        const dummyCount = itemsPerPage - currentItems.length;
        const dummyItems = Array.from({ length: dummyCount }, (_, index) => ({
            type: 'skeleton',
            key: `dummy-${index}`
        }));

        return [...currentItems, ...dummyItems];
    };

    const handlePageChange = (direction) => {
        if (direction === 'prev' && currentPage > 1) {
            audio1Ref.current.play();
            setCurrentPage(prev => prev - 1);
        } else if (direction === 'next' && currentPage < totalPages) {
            audio1Ref.current.play();
            setCurrentPage(prev => prev + 1);
        }
    };

    const { handleTouchStart, handleTouchEnd } = useTouchClick(
        () => { },
        10,
        (deltaX) => {
            // Swipe 기능 비활성화된 상태
        },
        true
    );

    return (
        <div>
                        <audio ref={audioRef} src={categorySound} preload="auto" />
                        <audio ref={audio1Ref} src={btnSound} preload="auto" />
            <div
                onPointerDown={handleTouchStart}
                onPointerUp={handleTouchEnd}
                style={{
                    width: "100%",
                    height: "58.5vh",
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    gap: "22px",
                    overflowX: 'visible'
                }}
            >
                <HorizontalBackButton onGoBackBtnClick={onGoBackBtnClick} />
                <StretchableHorizontalSlider
                    children={getCurrentPageItems().map((data, index) => {
                        if (data.type === 'skeleton') {
                            return (
                                <div 
                                    key={data.key} 
                                    style={{ 
                                        flex: "1 0 17%", 
                                        opacity: 0, 
                                        display: "flex", 
                                        justifyContent: "center", 
                                        alignItems: "center",
                                        height: "349px", 
                                    }}
                                >
                                    <SkeletonProductCard data={{}} />
                                </div>
                            );
                        }

                        return data.productName ? (
                            data.quantity > 0
                                ? <ProductCard3
                                    flex={"1 0 17%"}
                                    data={data}
                                    key={index}
                                    index={index + ((currentPage - 1) * 10)}
                                    filterProduct={true}
                                    setViewData={setViewData}
                                    currentProductIndex={currentProductIndex}
                                    setCurrentProductIndex={setCurrentProductIndex} />
                                : <SoldOutProductCard data={data} realQuantity={data.quantity} key={index} />
                        ) : data;
                    })}
                    pagingData={pagingData}
                    onPageChange={handlePageChange}
                    width='93%'
                />
            </div>

            <div style={{ transform: 'translate(46px,0)' }}>
                <SimplePagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                    bottom="-26.1vh"
                />
            </div>
        </div>
    )
}

export default DemoHorizontalProductListView;